import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=3860f2d9&scoped=true&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=3860f2d9&lang=scss&scoped=true&"
import style1 from "./DeleteModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860f2d9",
  null
  
)

export default component.exports